var _circle, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle2, _g, _g2, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLighthouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "0 0 291 291",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 145.5,
    fill: "#f1f3f4",
    r: 145.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.4 176.3c21 0 21-13.6 42-13.6s21 13.6 42 13.6 21-13.6 42-13.6 21 13.6 42 13.6 21-13.6 42-13.6c19.9 0 20.9 12.2 38.7 13.5 16-70.4-28.1-140.4-98.5-156.3s-140.3 28.1-156.3 98.4c-4.3 18.9-4.3 38.6-.1 57.5 2.1.3 4.2.5 6.3.5z",
    fill: "#304ffe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m132.9 33h34v31.5h-34z",
    fill: "#ffd54f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m132.9 33h12v31.5h-12z",
    fill: "#fff176"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.6,
    cy: 40.8,
    fill: "#fff176",
    rx: 8,
    ry: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m132.1 29.4c0-9.7 7.9-17.6 17.6-17.6s17.6 7.9 17.6 17.6",
    fill: "#f4511e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m149.8 11.8c9.6 0 17.4 7.8 17.4 17.5v.1h-17.4z",
    fill: "#e64a19"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m130.9 28.8h37.4c1.3 0 2.3 1 2.3 2.3s-1 2.3-2.3 2.3h-37.4c-1.3 0-2.3-1-2.3-2.3s1.1-2.3 2.3-2.3z",
    fill: "#f4511e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m128 161.5 4.9-97.3h34l4.4 92.5z",
    fill: "#c5cae9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m167.4 71.7 1.3 25.8",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m131.6 88.4-1.3 27 38.4-17.9-1.3-25.8z",
    fill: "#ff7043"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m170 122.8 1.3 25.8",
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m128.9 142-1.4 27 43.8-20.4-1.3-25.8z",
    fill: "#ff7043"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m127.7 49.9h43.9v14.4h-43.9z",
    fill: "#e64a19"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m127.7 49.9h28.8v14.4h-28.8z",
    fill: "#f4511e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m149.3 49.9c0 5.2-4.9 9.4-10.8 9.4s-10.8-4.2-10.8-9.4",
    fill: "#ffe082",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m205 45.9c1.2 0 2.3.3 3.3.7a13.9 13.9 0 0 1 26.8-3.6 9.3 9.3 0 1 1 0 18.6h-30.1c-4.4 0-7.9-3.5-7.9-7.9s3.5-7.8 7.9-7.8z",
    fill: "#2979ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m115.5 121.1c1 0 1.9.2 2.8.6.6-6.5 6.3-11.2 12.7-10.7 4.5.4 8.4 3.4 10 7.6 4.4-.2 8.1 3.1 8.3 7.5s-3.1 8.1-7.5 8.3h-26.2c-3.7-.1-6.6-3.3-6.4-6.9 0-3.5 2.8-6.3 6.3-6.4z",
    fill: "#448aff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.9,
    cy: 30.5,
    fill: "#fdd835",
    r: 1.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff9c4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193.4,
    cy: 110.1,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4,
    cy: 87.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 130.4,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.8,
    cy: 70.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.6,
    cy: 134.1,
    r: 2.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fdd835"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.1,
    cy: 143.3,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.2,
    cy: 114.7,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 107.3,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.1,
    cy: 74.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.4,
    cy: 78.2,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.1,
    cy: 137.4,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.6,
    cy: 69.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.8,
    cy: 138,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.7,
    cy: 102.5,
    r: 1.4
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m133.5 32.5s-66.5-9.3-66.7-9.3c-26 17-38 35-44 44l110.6-16.2z",
    fill: "#ffe082",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m168.2 64.2h-17.2v88.1l20.7 9.2z",
    fill: "#304ffe",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m108.7 176.6c21 0 21-13.6 42-13.6s21 13.6 42 13.6c17.8 0 20.5-9.8 33.8-12.8-18.1-9.9-45.1-16.2-75.3-16.2s-57.6 6.4-75.7 16.4c12.8 3.1 15.6 12.6 33.2 12.6z",
    fill: "#00c853"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m108.8 176.4c21 0 21-13.6 42-13.6h.4l-.2-15c-30 0-57 6.2-75 16 12.5 3.2 15.4 12.6 32.8 12.6z",
    fill: "#64dd17"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLighthouse);
export default __webpack_public_path__ + "static/media/LogoLIGHTHOUSE.9405fb6000d2a4a015e94dbd9df432f8.svg";
export { ForwardRef as ReactComponent };